var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { withFormik, Form } from 'formik';
import { useRecoilState, useRecoilValue } from 'recoil';
import { JsonForms } from '@jsonforms/react';
import { vanillaRenderers, vanillaCells } from '@jsonforms/vanilla-renderers';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { FormikCompatibleInput, formikCompatibleControlTester } from './Form/FormikCompatibleInput';
import { NoLayoutRenderer, noLayoutTester } from './Form/NoLayout';
import { FormNavigation } from './Ui/FormNavigation/FormNavigation';
import { appConfigState, appOrderState, appProductState, appProgressState, useProgress, useSetAppErrors, } from '../Domain/State/AppState';
import { AppServiceContext } from '../Domain/Context/AppServiceContext';
import { loadingSpinner } from './Ui/SpinnerButton/SpinnerButton';
import { useTrackPageWithCustomDimensions } from '../Tracking';
var InnerForm = function (props) {
    var renderers = __spreadArray(__spreadArray([], vanillaRenderers, true), [{ tester: formikCompatibleControlTester, renderer: FormikCompatibleInput },
        { tester: noLayoutTester, renderer: NoLayoutRenderer },], false);
    var values = props.values, configEntries = props.schema;
    var handleBack = props.handleBack, switching = props.switching;
    var forms = configEntries.map(function (_a) {
        var orderItem = _a.orderItem, quantity = _a.quantity, schema = _a.schema, uiSchema = _a.uiSchema;
        return (new Array(quantity)).fill(0).map(function (_, index) {
            var _a;
            var uiSchemaClone = __assign(__assign({}, uiSchema), { iteration: index });
            uiSchemaClone.elements = (_a = uiSchemaClone.elements) === null || _a === void 0 ? void 0 : _a.map(function (el) { return (__assign(__assign({}, el), { orderItem: orderItem, iteration: index })); });
            return _jsx(JsonForms, { data: values, renderers: renderers, cells: vanillaCells, schema: schema, uischema: uiSchemaClone }, index);
        });
    });
    var trackingPrefix = useRecoilValue(appConfigState).trackingPrefix;
    return (_jsx(_Fragment, { children: _jsxs(Form, __assign({ id: "".concat(trackingPrefix, "-additional-data-step") }, { children: [switching ? loadingSpinner({ class: 'blue' }) : forms, _jsx("p", { children: "Mit * markierte Felder sind Pflichtfelder" }), _jsx(FormNavigation, { handleBack: handleBack, switching: switching })] })) }));
};
var OuterForm = withFormik({
    validateOnChange: false,
    validateOnBlur: false,
    mapPropsToValues: function (_a) {
        var initialValues = _a.initialValues;
        return initialValues;
    },
    handleSubmit: function (values, formikBag) {
        var _a = formikBag.props, handleSubmit = _a.handleSubmit, schema = _a.schema;
        var filteredValue = Object.fromEntries(Object.entries(values).filter(function (_a) {
            var key = _a[0];
            return !['schema', 'switching'].includes(key);
        }));
        var hasErrors = false;
        var requiredSchema = {};
        schema.forEach(function (entry) {
            requiredSchema[entry.orderItem] = entry.schema.required || [];
        });
        var errors = {};
        Object.entries(filteredValue).forEach(function (_a) {
            var orderItemId = _a[0], orderItemEntries = _a[1];
            errors[orderItemId] = orderItemEntries.map(function (fields) {
                var entryErrors = {};
                Object.entries(fields).forEach(function (_a) {
                    var fieldKey = _a[0], fieldValue = _a[1];
                    if (requiredSchema[orderItemId].includes(fieldKey) && !fieldValue) {
                        hasErrors = true;
                        entryErrors[fieldKey] = 'Bitte füllen Sie das Feld aus';
                    }
                });
                return entryErrors;
            });
        });
        if (!hasErrors) {
            var keys = Object.keys(filteredValue).map(function (orderItem) { return ({
                orderItem: orderItem,
                individualizations: values[orderItem],
            }); });
            handleSubmit(keys);
            return;
        }
        formikBag.setSubmitting(false);
        formikBag.setErrors(errors);
    },
})(InnerForm);
export var AmountDependentData = function () {
    var _a = useState([]), schema = _a[0], setSchema = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState({}), initialValues = _c[0], setInitialValues = _c[1];
    var pushInstruction = useMatomo().pushInstruction;
    var orderService = (useContext(AppServiceContext) || {}).orderService;
    var switching = useRecoilValue(appProgressState).switching;
    var formSchemaJson = useRecoilValue(appProductState).formSchemaJson;
    var orderItems = (useRecoilValue(appOrderState) || {}).items;
    var _d = useRecoilState(appOrderState), order = _d[0], setOrder = _d[1];
    var _e = useProgress(), stepForward = _e.stepForward, stepBackward = _e.stepBackward, setSwitching = _e.setSwitching;
    var updateErrorMessage = useSetAppErrors().updateErrorMessage;
    var trackingPrefix = useRecoilValue(appConfigState).trackingPrefix;
    useEffect(function () {
        setSwitching(false);
    }, []);
    useEffect(function () {
        if (formSchemaJson && Array.isArray(orderItems) && orderItems.length > 0) {
            var schemaEntries_1 = [];
            orderItems.forEach(function (orderItem) {
                var id = orderItem.id, quantity = orderItem.quantity, individualization = orderItem.individualization;
                var individualizationArray = [];
                if (individualization && individualization !== '') {
                    individualizationArray = JSON.parse(individualization);
                }
                var schemaEntry = __assign(__assign({}, formSchemaJson), { orderItem: id, quantity: quantity });
                var initial = {};
                var emptyFields = {};
                Object.keys(formSchemaJson.schema.properties).forEach(function (property) {
                    emptyFields[property] = '';
                });
                initial[id] = new Array(quantity)
                    .fill(null)
                    .map(function (_, index) { return Object.assign(emptyFields, individualizationArray[index]); });
                setInitialValues(initial);
                schemaEntries_1.push(schemaEntry);
            });
            setSchema(schemaEntries_1);
            setIsLoading(false);
        }
    }, [formSchemaJson, orderItems]);
    function trackFormSubmit() {
        var form = document.getElementById("".concat(trackingPrefix, "-additional-data-step"));
        pushInstruction('FormAnalytics::trackFormSubmit', form);
    }
    var handleSubmit = function (individualizations) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            trackFormSubmit();
            setIsLoading(true);
            if (orderService && (order === null || order === void 0 ? void 0 : order.tokenValue)) {
                orderService
                    .addIndividualization(order.tokenValue, individualizations, setOrder).then(function () {
                    stepForward();
                });
            }
            else {
                updateErrorMessage('Bitte kontaktieren Sie den Webseiten-Support. Fehler: Es wurde kein Warenkorb gefunden.');
                setSwitching(false);
            }
            return [2 /*return*/];
        });
    }); };
    useTrackPageWithCustomDimensions();
    useEffect(function () {
        setTimeout(function () {
            var form = document.getElementById("".concat(trackingPrefix, "-additional-data-step"));
            if (form) {
                pushInstruction('FormAnalytics::trackForm', form);
            }
        }, 500);
    }, []);
    return (function () {
        if (isLoading) {
            return (_jsxs("div", __assign({ className: "form-page" }, { children: [_jsx("div", __assign({ className: "field field--text col col-12 col-md-12" }, { children: _jsx("label", { children: "Bitte geben Sie weitere Informationen an" }) })), loadingSpinner({ class: 'blue' }), _jsx(FormNavigation, { handleBack: stepBackward, switching: switching || isLoading, handleClick: stepForward })] })));
        }
        if (schema && schema.length > 0) {
            return (_jsxs("div", __assign({ className: "form-page" }, { children: [_jsx("div", __assign({ className: "field field--text col col-12 col-md-12" }, { children: _jsx("label", { children: "Bitte geben Sie weitere Informationen an" }) })), _jsx(OuterForm, { initialValues: initialValues, handleBack: stepBackward, switching: switching || isLoading, handleSubmit: handleSubmit, schema: schema })] })));
        }
        return (_jsxs("div", __assign({ className: "form-page" }, { children: [_jsxs("div", __assign({ className: "field field--text col col-12 col-md-12" }, { children: [_jsx("label", { children: "Es werden keine Zusatzinformationen ben\u00F6tigt" }), _jsx("div", __assign({ className: "field__text" }, { children: "F\u00FCr dieses Produkt werden keine Zusatzinformationen ben\u00F6tigt. Sie k\u00F6nnen zum n\u00E4chsten Schritt im Kaufprozess gehen. Vielen Dank." }))] })), _jsx(FormNavigation, { handleBack: stepBackward, switching: switching, handleClick: stepForward })] })));
    })();
};
